import React from "react";
import Logo from "assets/black-logo.png";
import { Col, Container, Image, Row, Spinner } from "react-bootstrap";

const LogoLoading = ({ text = "Loading..." }) => {
  return (
    <Container
      fluid
      className="mt-5 d-flex justify-content-center align-items-center"
    >
      <Row>
        <Col xs={3} md={5}></Col>
        <Col xs={6} md={2} className="text-center">
          <Image src={Logo} width="100%" />
        </Col>
        <Col xs={3} md={5}></Col>
        <Col xs={12} className="text-center">
          <Spinner size="sm" /> <span className="h5">{text}</span>
        </Col>
      </Row>
    </Container>
  );
};

export default LogoLoading;
